import {mapActions} from 'vuex'
export default {
  name: 'tabs-alt',
  components: {},
  props: [],
  data() {
    return {
      tabsAlt: [],
      isClicked: false,
    };
},

created() {
    
    this.tabsAlt = this.$children;
    
},
mounted: function () {
  window.setInterval(() => {
    this.rotateTab()
  }, 4000)
},
methods: {
    ...mapActions(['change_LP_activeTab']),
    selectTab(selectedTab) {
        this.tabsAlt.forEach((tab, index) => {
            tab.isActive = (tab.name == selectedTab.name);
            console.log(tab.isActive)
            if (tab.isActive == true){
              this.$store.dispatch('change_LP_activeTab', index)
            }
        });
        this.isClicked = true;
        console.log(this.tabsAlt[0].name)
    }, 
    rotateTab: function(){
      if(this.isClicked){
        return true;
      }
      var nextTab = this.tabsAlt;
      var setNextTab = true;
      var tabIndex;
      this.tabsAlt.forEach(function(tab, index) {
        if (tab.isActive){
          
          if (index < 2 && setNextTab == true){
            nextTab[index + 1].isActive = true;
            nextTab[index].isActive = false;
            setNextTab = false;
            tabIndex = index + 1;
            
          }
          if (index == 2 && setNextTab == true){
            nextTab[0].isActive = true;
            nextTab[index].isActive = false;
            setNextTab = false
            tabIndex = 0;
          }
        }
      });
      this.$store.dispatch('change_LP_activeTab', tabIndex)
    this.tabsAlt = nextTab;
    }
  }
}



